export const projects = [
  {
    name: "Untitled Memories Game",
    date: "Jan 2022",
    title: "Programmer, Designer",
    description:
      "A quiet, narrative-driven disjointed sequence of my childhood memories. Submitted for Global Game Jam 2022.",
    image: "./pictures/memgame.png",
    link: "https://jelloboy.itch.io/memoriesgame"
  },
  {
    name: "Found a Friend",
    date: "Jan 2021",
    title: "Solo Dev",
    description:
      "A short, quiet walking simulator made for Global Game Jam 2021 about finding your lost friend. I made this game solo over the course of 2 days.",
    image: "./pictures/foundafriend.png",
    link: "https://jelloboy.itch.io/found-a-friend"
  },
  {
    name: "Moon Game",
    date: "Oct 2020",
    title: "Programmer",
    description:
      "A short, silly dating sim made for a Game Jam. I made this with my Egghouse team (As It Is).",
    image: "./pictures/moongame.png",
    link: "https://jelloboy.itch.io/moon-game"
  },
  {
    name: "Umami Blast",
    date: "Aug 2018 - May 2019",
    title: "Lead Engineer",
    description:
      "A mobile match-3 game sponsored by Zynga during my last year in College. I was lead engineer over a team of 3.",
    image: "./pictures/umamiblast.png",
    link: ""
  },
  {
    name: "GeoMetric",
    date: "Aug 2017 - Dec 2017",
    title: "Programmer, Artist",
    description:
      "A 2D physics-based, skill-focused platformer I built in school with another programmer and a composer.",
    image: "./pictures/geometric.png",
    link: "https://jelloboy.itch.io/geometric"
  },
  {
    name: "The Last Epoch",
    date: "Dec 2017 - Jan 2018",
    title: "Prototyper",
    description:
      "I volunteered to work briefly on this project as a developer. During my time on the team, I prototyped a card game in collaboration with a volunteer designer.",
    image: "./pictures/lastepoch.jpg",
    link: "https://lastepoch.com/"
  },
  {
    name: "Super Boom Boy",
    date: "Jun 2014 - Aug 2014",
    title: "Audio Arranger",
    description:
      "A Super Bomberman-inspired game with one new feature: wall wrapping. Created at a Pre-College program at Carnegie Mellon University.",
    image: "./pictures/newgame.png",
    link: ""
  },
];



export const skills = [
  {
    name: "C#",
    type: "language"
  },
  {
    name: "C++",
    type: "language"
  },
  {
    name: "Unity",
    type: "tool"
  },
  {
    name: "Git",
    type: "tool"
  },
  {
    name: "Jira",
    type: "tool"
  },
  {
    name: "Clickup",
    type: "tool"
  },
];

export const smallskills = [
  {
    name: "Java",
    type: "language",
  },
  {
    name: "Python",
    type: "language",
  },
  {
    name: "Flutter",
    type: "tool",
  },
  {
    name: "React",
    type: "tool",
  },
  {
    name: "Jenkins",
    type: "tool",
  },
]

export const translations = [
  {
    name: "Orange",
    image: "./pictures/orange.jpg",
    progress: "Book 7, Chapters 27-33",
    link: "https://mangadex.org/title/cffdc4f4-0cd9-409b-b88c-62aaf2882e07/orange",
  },
  {
    name: "Candy & Cigarettes",
    image: "./pictures/cc.jpg",
    progress: "Books 6-9, Chapters 28-48",
    link: "https://mangadex.org/title/1d73115f-b53f-4c35-85fd-72b958554ec0/candy-cigarettes",
  },
];

export const artworks = [
  {
    name: "Reze",
    type: "Landscape",
    src: "./artworks/reze.png"
  },
  {
    name: "March",
    type: "Portrait",
    src: "./artworks/march.png"
  },
  {
    name: "Comic",
    type: "Portrait",
    src: "./artworks/comic.png"
  },
  {
    name: "Ekko",
    type: "Portrait",
    src: "./artworks/ekko.png"
  },
  {
    name: "Chitose",
    type: "Portrait",
    src: "./artworks/chitose2.png"
  },
  {
    name: "Chitose",
    type: "Portrait",
    src: "./artworks/chitose.png"
  },
  {
    name: "Asleep",
    type: "Landscape",
    src: "./artworks/asleep.png"
  },
  {
    name: "Mitama",
    type: "Portrait",
    src: "./artworks/mitama.png"
  },
  {
    name: "Isaac",
    type: "Portrait",
    src: "./artworks/isaac.png"
  },
  {
    name: "Cup",
    type: "Portrait",
    src: "./artworks/cup.png"
  },
  {
    name: "Buggy",
    type: "Landscape",
    src: "./artworks/buggee.png"
  },
  {
    name: "Apple Sidra",
    type: "Portrait",
    src: "./artworks/applesidra.png"
  },
  {
    name: "Queen Simp",
    type: "Portrait",
    src: "./artworks/queensimp.png"
  },
  {
    name: "Bad Thoughts",
    type: "Portrait",
    src: "./artworks/badthoughts.png",
  },
  {
    name: "Foudo Weekly Challenge, 1/29/24",
    type: "Portrait",
    src: "./artworks/foudoweekly12924.png",
  },
  {
    name: "Lavender Guy",
    type: "Landscape",
    src: "./artworks/lavenderguy.png",
  },
  {
    name: "Himari and Kirby",
    type: "Portrait",
    src: "./artworks/himariandkirby.png",
  },
  {
    name: "Kirbo Sleeping",
    type: "Portrait",
    src: "./artworks/kirbosleeping.png",
  },
  {
    name: "Kirbo at the Beach",
    type: "Landscape",
    src: "./artworks/kirbobeach.png",
  },
  {
    name: "Holo",
    type: "Portrait",
    src: "./artworks/holored.png",
  },
]

export const modelling = [
  {
    name: "1",
    src: "./modelling/modelling_1.jpg"
  },
  {
    name: "2",
    src: "./modelling/modelling_2.jpg"
  },
  {
    name: "3",
    src: "./modelling/modelling_3.jpg"
  },
  {
    name: "4",
    src: "./modelling/modelling_4.jpg"
  },
]